
export enum AsyncComponentMeasureEnum {
    MeasureMutate = 'MeasureMutate',
    MeasureTabs = 'MeasureTabs',
    MeasureList = 'MeasureList',
    MeasureListForm = 'MeasureListForm',
    MeasureMutateForm = 'MeasureMutateForm',

    MeasureGroupMutate = 'MeasureGroupMutate',
    MeasureGroupList = 'MeasureGroupList',
    MeasureGroupListForm = 'MeasureGroupListForm',
    MeasureGroupMutateForm = 'MeasureGroupMutateForm',
    MeasureGroupTabs = 'MeasureGroupTabs',
    MeasureGroupSelector = 'MeasureGroupSelector',
    MeasureSelector = 'MeasureSelector',


}

export const measureComponents = {
    [ AsyncComponentMeasureEnum.MeasureListForm ]: () => import( '@/components/measure/MeasureListForm.vue' ),
    [ AsyncComponentMeasureEnum.MeasureMutateForm ]: () => import( '@/components/measure/MeasureMutateForm.vue' ),
    [ AsyncComponentMeasureEnum.MeasureMutate ]: () => import( '@/views/measure/measureMutate/MeasureMutate.vue' ),

    [ AsyncComponentMeasureEnum.MeasureTabs ]: () => import( '@/components/measure/MeasureTabs.vue' ),
    [ AsyncComponentMeasureEnum.MeasureList ]: () => import( '@/views/measure/measureList/MeasureList.vue' ),

    [ AsyncComponentMeasureEnum.MeasureGroupListForm ]: () => import( '@/components/measure/MeasureGroupListForm.vue' ),
    [ AsyncComponentMeasureEnum.MeasureGroupMutateForm ]: () => import( '@/components/measure/MeasureGroupMutateForm.vue' ),
    [ AsyncComponentMeasureEnum.MeasureGroupMutate ]: () => import( '@/views/measure/measureGroupMutate/MeasureGroupMutate.vue' ),
    [ AsyncComponentMeasureEnum.MeasureGroupList ]: () => import( '@/views/measure/measureGroupList/MeasureGroupList.vue' ),
    [ AsyncComponentMeasureEnum.MeasureGroupTabs ]: () => import( '@/components/measure/MeasureGroupTabs.vue' ),
    [ AsyncComponentMeasureEnum.MeasureGroupSelector ]: () => import( '@/components/measure/MeasureGroupSelector.vue' ),
    [ AsyncComponentMeasureEnum.MeasureSelector ]: () => import( '@/components/measure/MeasureSelector.vue' ),

}
